import ModelTypeConstants from 'constants/ModelTypeConstants';

export const PLATE_DESIGN_TEMPLATE_TABLE_NAME = 'scratch_plate_design';

export const TEMPLATE_COLLECTION_SETTINGS_MENU_ITEM_LABEL = 'Template collection settings';
export const COPY_TEMPLATE_COLLECTION_LINK_MENU_ITEM_LABEL = 'Copy template collection link';

export const TEMPLATE_COLLECTIBLE_TYPES = [
  ModelTypeConstants.TEMPLATE,
  ModelTypeConstants.SUBTEMPLATE,
  ModelTypeConstants.FORM_DEFINITION,
  ModelTypeConstants.REQUEST_V2_DEFINITION,
  ModelTypeConstants.ASSAY_PROCEDURE,
  ModelTypeConstants.RECIPE_PROCEDURE,
  ModelTypeConstants.ANALYSIS_TEMPLATE,
  ModelTypeConstants.PLATE_DESIGN_TEMPLATE,
];

/** Template collections and the collectible types that can belong to them. */
export const TEMPLATE_COLLECTION_AND_COLLECTIBLE_TYPES = [
  ModelTypeConstants.TEMPLATE_COLLECTION,
  ...TEMPLATE_COLLECTIBLE_TYPES,
];
